import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const burpSuiteEnterprise = defineConnector({
  identifier: "burpSuiteEnterprise",
  name: "Burp Suite DAST",
  tagLine: "Dynamic application security testing",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ baseUrl }) =>
    exactUrlToRegex(baseUrl || "https://burp.example.com"),
  auth: headerAuth([
    { name: "Authorization", value: { from: "secret", field: "apiKey" } },
    {
      name: "Content-Type",
      value: { from: "literal", value: "application/json" },
    },
  ]),
  steps: [
    {
      title: "Set up Burp Suite DAST",
      items: [
        {
          kind: "markdown",
          content:
            "In Burp Suite DAST, open **Team > Add a new user**, select **API Key** as the login type, and assign the roles needed to read sites and folders. Save the user and copy the API key. See [creating API users](https://portswigger.net/burp/documentation/dast/user-guide/api-documentation/create-api-user).",
        },
      ],
    },
    {
      title: "Enter connection details",
      items: [
        {
          kind: "baseUrl",
          label: "API base URL",
          required: true,
          placeholder: "https://burp.example.com",
          target: {
            kind: "configuration",
            field: "baseUrl",
          },
          helperText:
            "Enter your Burp Suite DAST server URL, including its configured port. The connector appends /graphql/v1 for its connection test.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: {
            kind: "secrets",
            field: "apiKey",
          },
          helperText:
            "Create a dedicated Burp Suite DAST API user, select API Key as the login type, save the user, and securely copy the generated API key.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url:
        (baseUrl || "https://burp.example.com").trim().replace(/\/+$/, "") +
        "/graphql/v1",
      ...{
        method: "POST",
        expectedBodyContains: ['"site_tree"', '"folders"'],
        headers: { "Content-Type": "application/json" },
        body: '{"query":"query ConnectionTest { site_tree { folders { id } } }"}',
      },
    }),
  },
});
